// extracted by mini-css-extract-plugin
export default {"feed":"Feed_feed__QlCsS"};